import { Grid, GridColumn } from 'semantic-ui-react';
import ReactGA from 'react-ga4';

import { useProjectContext } from '~/hooks';
import PricingEstimateWorksheet from '../projectWizard/worksheets/pricingEstimate/PricingEstimateWorksheet';
import PricingEstimateQuoteTable from './Quote/PricingEstimateQuoteTable';


export default function PricingEstimateReview() {
  const { project } = useProjectContext();

  ReactGA.send({
    hitType: 'pageview',
    page: '/pricing-estimate/id/review',
    title: `${project?.name} | Conductor Solar`
  });
  document.title = `${project?.name} | Conductor Solar`;

  return (
    <Grid stackable>
      <GridColumn width={8}>
        <div className="card">
          <PricingEstimateWorksheet />
        </div>
      </GridColumn>

      <GridColumn width={4}>
          <PricingEstimateQuoteTable />
      </GridColumn>
    </Grid>
  );
}